module.exports = __webpack_public_path__ + "img/lateral-direita.bf065d40.webp";